import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-warning/20 border border-warning rounded-lg p-3 text-sm text-yellow-800 mb-4",
  "data-testid": "no-available-roles-message"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col gap-y-2 mb-4",
  "data-testid": "role-selector"
}
const _hoisted_3 = { class: "text-md font-bold text-left" }
const _hoisted_4 = { class: "flex gap-x-2" }

import { VALIDATION_ROLE_LABELS, type ValidationRole } from '@/types/approval-flow.types'

/**
 * Seletor do papel com que o usuário vota num fluxo de validação. Com um papel
 * só não renderiza nada (o voto sai com ele); sem papéis, mostra o aviso quando
 * `showEmptyWarning` estiver ligado. Par do composable `useApprovalRole`.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    roles: {},
    modelValue: {},
    label: { default: 'Aprovar como' },
    showEmptyWarning: { type: Boolean, default: false },
    emptyMessage: { default: 'Você já registrou sua decisão neste fluxo ou não possui permissão para os papéis pendentes.' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_ctx.roles.length === 0 && _ctx.showEmptyWarning)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.emptyMessage), 1))
    : (_ctx.roles.length >= 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.label), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
              return (_openBlock(), _createBlock(_component_v_chip, {
                key: role,
                variant: _ctx.modelValue === role ? 'flat' : 'outlined',
                color: _ctx.modelValue === role ? 'primary' : undefined,
                "data-testid": `role-selector-chip-${role}`,
                onClick: ($event: any) => (emit('update:modelValue', role))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(VALIDATION_ROLE_LABELS)[role] ?? role), 1)
                ]),
                _: 2
              }, 1032, ["variant", "color", "data-testid", "onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
}
}

})